import React from 'react';
import { Route } from 'react-router-dom';
import usePortalAuth from '../../../auth/usePortalAuth';
import LoginRedirect from '../../Login/LoginRedirect';

const PrivateRoute = ({ component: Component, render: renderProp, path, location, accessLevel, ...rest }) => {
  const { isLoading, isAuthenticated } = usePortalAuth();

  const render = (props) => {
    // Wait until auth state has resolved before deciding to redirect.
    // The 2-second timer hack was insufficient for cold-start cross-origin fetches.
    if (isLoading) {
      return null;
    }
    if (!isAuthenticated) {
      return <LoginRedirect history={props.history} />;
    }
    // Prefer `render` prop over `component` so inline render functions don't
    // cause a remount of the subtree on every parent re-render.
    if (typeof renderProp === 'function') {
      return renderProp(props);
    }
    return <Component {...props} />;
  };

  return (
    <Route
      path={path}
      render={(props) => render(props)}
      {...rest}
    />
  );
};

export default PrivateRoute;
